export default "__VITE_ASSET__Do27h5S$__"